<template>
  <div class="review-page">

    <!-- CARD -->
    <div class="review-card">

      <!-- BRAND HEADER -->
      <div class="brand-header">

         <div class="brand-logo" v-if="businessLogo">
          <img :src="base_url + businessLogo">
        </div>

         <div class="brand-logo" v-if="!businessLogo">
          <img src="/images/logo.png">
        </div>

        <h2 class="brand-title">
          {{ businessName }}
        </h2>

        <!-- <p class="brand-subtitle">
          {{ businessDesc }}
        </p> -->

      </div>

      <!-- TITLE -->
      <h1>Refer a Friend</h1>
      <p>{{ businessDesc }}</p>

      <!-- FORM -->
      <div class="review-form">

        <div class="form-group">
          <label>Your Name</label>
          <input v-model="form.name" placeholder="John Doe" />
        </div>
        <div class="form-group">
          <label>Friend Name</label>
          <input v-model="form.fname" placeholder="John Doe" />
        </div>

        <div class="form-group">
          <label>Friend Email</label>
          <input v-model="form.email" placeholder="john@email.com" />
        </div>

        <div class="form-group">
          <label>Friend Mobile</label>

          <div class="phone-input">

            <select v-model="form.countryCode">
              <option value="+91">🇮🇳 +91 India</option>
              <option value="+1">🇺🇸 +1 USA</option>
              <option value="+44">🇬🇧 +44 UK</option>
              <option value="+61">🇦🇺 +61 Australia</option>
              <option value="+971">🇦🇪 +971 UAE</option>
            </select>

            <input
              type="tel"
              v-model="form.mobile"
              placeholder="**********"
            />

          </div>
        </div>

        <div class="form-group">
          <label>Message (Optional)</label>
          <textarea
            v-model="form.review"
            placeholder="Write a short message..."
          ></textarea>
        </div>

        <button
          class="primary-btn"
          :disabled="!isFormValid"
          @click="submitReferral"
        >
          Send Referral
        </button>

      </div>

    </div>

    <!-- FOOTER -->
    <div class="review-footer">
      <span>🔒 Secure Referral Portal</span>
      <span>✔ End-to-End Encrypted</span>
    </div>

    <!-- SUCCESS POPUP -->
    <div v-if="popup.show" class="popup-overlay">

      <div class="popup-card">

        <span class="material-symbols-outlined success-icon">
          check_circle
        </span>

        <h3>{{ popup.title }}</h3>
        <p>{{ popup.message }}</p>

        <button class="popup-btn" @click="popup.show = false">
          Continue
        </button>

      </div>

    </div>

  </div>
</template>
<script>

import { sendReferral, getRefById } from "@/apis/referralapis";
import { apiBaseUrl } from "@/apis/appconst";
import { useToast } from "vue-toastification";

export default {

  name: "ReferralComp",

  data() {
    return {

      toast:null,

      camp_id:"",
      camp_dt:null,

      businessName:"********",
      businessLogo:"/images/logo.png",
      businessDesc:"********",

      base_url:"",

      form:{
        fname:"",
        name:"",
        email:"",
        mobile:"",
        countryCode:"+91",
        review:""
      },

      popup:{
        show:false,
        title:"",
        message:""
      }

    }
  },

  mounted(){

    this.toast = useToast();
    this.base_url = apiBaseUrl;

    const segments = window.location.pathname.split("/").filter(seg => seg !== "")+"";
    this.camp_id = segments.split(",")[1]+"";

    this.getCampDt();

  },

  computed:{

    isFormValid(){

      return (
        this.form.name.trim() &&
        this.form.email.trim()&&
        this.form.fname.trim()&&
        this.form.countryCode.trim()&&
        this.form.mobile.trim()
      );

    }

  },

  methods:{

    async getCampDt(){

      try{

        const res = await getRefById(this.camp_id);

        if(!res.status){
          return;
        }

        this.camp_dt = res.ref_dt;

        this.businessName = this.camp_dt.ref_camp_name;
        this.businessDesc = this.camp_dt.ref_camp_desc;
        this.businessLogo = this.camp_dt.ref_camp_logo;


      }
      catch(error){
        console.error(error);
        this.toast.error("Failed to load campaign");
      }

    },

    showPopup(title,message){

      this.popup.title = title;
      this.popup.message = message;
      this.popup.show = true;

    },

    async submitReferral(){

      if(!this.isFormValid){
        this.toast.error("Please fill required fields");
        return;
      }

      try{

        const res = await sendReferral(

          this.camp_id,
          this.form.name,
          this.form.fname,
          this.form.countryCode + this.form.mobile,
          this.form.email,
          this.form.review

        );

        if(!res.status){
          this.toast.error(res.success);
          return;
        }

        this.form.name = "";
        this.form.fname = "";
        this.form.countryCode = "+91";
        this.form.mobile = "";
        this.form.email = "";
        this.form.review = "";

        this.showPopup(
          "Referral Sent",
          "Thank you for sharing this referral."
        );

        this.resetForm();

      }
      catch(error){

        console.error(error);
        this.toast.error("Submission failed");

      }

    },

    resetForm(){

      this.form.name = "";
      this.form.email = "";
      this.form.mobile = "";
      this.form.review = "";

    }

  }

}

</script>
<style scoped>

/* PAGE */

.review-page{
  min-height:100vh;
  background:linear-gradient(to bottom right,#f8fafc,rgba(25,127,230,0.05));
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  padding:24px;
  font-family:'Inter',sans-serif;
}


/* CARD */

.review-card{
  width:100%;
  max-width:520px;
  background:white;
  border-radius:22px;
  padding:34px;
  box-shadow:0 20px 50px rgba(0,0,0,0.06);
  text-align:center;
  border:1px solid #eef2f7;
}

.review-card h1{
  font-size:26px;
  font-weight:900;
  color:#0f172a;
}

.review-card p{
  margin-top:6px;
  color:#64748b;
  font-size:14px;
}


/* BRAND HEADER */

.brand-header{
  display:flex;
  flex-direction:column;
  align-items:center;
  text-align:center;
  margin-bottom:26px;
}

.brand-logo{
  height:5rem;
  background:white;
  display:flex;
  align-items:center;
  justify-content:center;
  overflow:hidden;
  margin-bottom:12px;
}

.brand-logo img{
  width:auto;
  height:5rem;
  object-fit:cover;
}

.brand-title{
  font-weight:800;
  font-size:20px;
}

.brand-subtitle{
  font-size:13px;
  max-width:280px;
  color:#64748b;
}


/* FORM */

.review-form{
  margin-top:18px;
  display:flex;
  flex-direction:column;
  gap:14px;
}

.form-group{
  display:flex;
  flex-direction:column;
  gap:6px;
  text-align:left;
}

.form-group label{
  font-size:12px;
  font-weight:600;
  color:#475569;
}

.form-group input,
.form-group textarea{
  width:100%;
  border:1px solid #e2e8f0;
  border-radius:10px;
  padding:10px 12px;
  font-size:13px;
  transition:0.2s;
}

.form-group textarea{
  resize:none;
  min-height:90px;
}

.form-group input:focus,
.form-group textarea:focus{
  outline:none;
  border-color:#197fe6;
  box-shadow:0 0 0 3px rgba(25,127,230,0.08);
}


/* PHONE INPUT */

.phone-input{
  display:flex;
  gap:8px;
}

.phone-input select{
  width:120px;
  border:1px solid #e2e8f0;
  border-radius:10px;
  padding:10px;
  font-size:13px;
  background:white;
}

.phone-input input{
  flex:1;
}


/* BUTTON */

.primary-btn{
  height:46px;
  border-radius:12px;
  background:#197fe6;
  color:white;
  font-size:14px;
  font-weight:700;
  border:none;
  cursor:pointer;
  transition:0.2s;
  margin-top:6px;
}

.primary-btn:hover{
  transform:translateY(-1px);
  box-shadow:0 10px 20px rgba(25,127,230,0.25);
}

.primary-btn:disabled{
  opacity:0.5;
  cursor:not-allowed;
  transform:none;
  box-shadow:none;
}


/* FOOTER */

.review-footer{
  margin-top:18px;
  display:flex;
  gap:20px;
  font-size:11px;
  color:#94a3b8;
}


/* POPUP */

.popup-overlay{
  position:fixed;
  inset:0;
  background:rgba(15,23,42,0.35);
  display:flex;
  align-items:center;
  justify-content:center;
  z-index:999;
}

.popup-card{
  width:100%;
  max-width:380px;
  background:white;
  border-radius:18px;
  padding:26px;
  text-align:center;
  box-shadow:0 30px 60px rgba(0,0,0,0.12);
  animation:popupEnter .25s ease;
}

.success-icon{
  font-size:42px;
  color:#22c55e;
  margin-bottom:10px;
}

.popup-card h3{
  font-size:18px;
  font-weight:800;
  color:#0f172a;
}

.popup-card p{
  font-size:13px;
  color:#64748b;
  margin-top:6px;
}

.popup-btn{
  margin-top:16px;
  height:42px;
  width:100%;
  border-radius:10px;
  background:#197fe6;
  color:white;
  font-weight:700;
  border:none;
  cursor:pointer;
}

.popup-btn:hover{
  background:#0f6ad6;
}

@keyframes popupEnter{
  from{
    transform:scale(.96);
    opacity:0;
  }
  to{
    transform:scale(1);
    opacity:1;
  }
}


/* MOBILE */

@media (max-width:768px){

  .review-card{
    padding:24px;
    border-radius:18px;
  }

  .review-card h1{
    font-size:22px;
  }

  .review-footer{
    flex-direction:column;
    gap:6px;
    text-align:center;
  }

}

</style>